import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

/**
 * SuperAdminGuard — restricts /super-admin/* routes to super-admin users only.
 *
 * Add to all super-admin routes:
 *   { path: 'super-admin', canActivate: [SuperAdminGuard], loadChildren: ... }
 */
@Injectable({ providedIn: 'root' })
export class SuperAdminGuard implements CanActivate {

    constructor(
        private permissionService: PermissionService,
        private router: Router,
    ) {}

    canActivate(): boolean {
        if (this.permissionService.isSuperAdmin()) return true;
        this.router.navigate(['/dashboard']);
        return false;
    }
}
